import React, { useEffect, useState } from 'react'
import { Table } from '../../components/Table/Table'
import { delete_icon, edit_icon, eye_icon, password_icon, search_icon, toggle_off, toggle_on, view_icon } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLazyAdminListStatusQuery, useLazyUsersListQuery, useLazyUsersListStatusQuery, useUsersListMutation } from '../redux/api/api';
import moment from 'moment';
import { toast } from 'react-toastify';

const UsersList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [list, setList] = useState([]);
    const [pageno, setPageno] = useState(1);
    const [pagecount, setPagecount] = useState("");
    const [count, setCount] = useState();


    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))
    const [usersListApi] = useUsersListMutation();
    const [userListStatus] = useLazyUsersListStatusQuery();



    const userStatus = (id) => {
        userListStatus(id)
            .unwrap()
            .then((res) => {
                console.log("reasds", res);
                if (res?.status == "success") {
                    toast.success(res?.message);
                    usersList()
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const usersList = (page, search) => {
        const formdata = new FormData();
        formdata.append("page", page)
        formdata.append("row", 10)
        if (search) {
            formdata.append('search', search)
        }
        usersListApi(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                let temp = []
                res?.data?.map((item, ind) => {
                    let obj = { ...item }
                    obj.current_page = res?.pagination?.current_page
                    temp.push(obj)
                })
                setList(temp);
                setCount(res?.pagination?.total);
                setPagecount(res?.pagination)
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    useEffect(() => {
        usersList(pageno);
    }, [pageno]);

    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                }
            },

            {
                Header: "User Id",
                accessor: "user_id",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"><p className='pointer hoverline' onClick={() => navigate('/user-view', { state: { type: "view", id: row.original.id } })}>{value}</p></div>
                },
            },
            {
                Header: " Name",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className='pointer hoverline' onClick={() => navigate('/user-view', { state: { type: "view", id: row.original.id } })}>{value}</p></div>
                },
            },
            // {
            //     Header: "Total Booking",
            //     accessor: "total_bookings",
            //     Cell: ({ value, row }) => {
            //         return <p>{value}</p>;
            //     },
            // },
            {
                Header: "Registered Date",
                accessor: "created_at",
                Cell: ({ value, row }) => {
                    return <p>{moment(value).format("DD-MM-YYYY")}</p>;
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <select disabled={(row.original.account_status == 1 && rolePermissions?.includes('CAN-STATUS-USERS')) ? false : true}
                                value={value}
                                onChange={() => { userStatus(row.original.id) }}
                                className={`fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 ${value == 1 ? "active-btn" : "suspend-btn"}`}
                            >
                                <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={1}>
                                    Active
                                </option>
                                <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={0}>
                                    Deactive
                                </option>
                            </select>
                        </React.Fragment >
                    );
                },
            },
            {
                Header: "Account Status",
                accessor: "account_status",
                Cell: ({ value, row }) => {
                    return <p>{value == 1 ? "Active" : value == 0 ? "Deactive" : ""}</p>
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                {rolePermissions?.includes('CAN-VIEW-USERS') &&
                                    <button
                                        onClick={() => navigate('/user-view', { state: { type: "view", id: row.original.id } })}
                                        className="cust-btn "
                                    >
                                        <img src={view_icon} alt="" className="mx-2 edit-btn " />
                                    </button>
                                }
                                {rolePermissions?.includes('CAN-EDIT-USERS') &&
                                    <button
                                        onClick={() => navigate('/user-view', { state: { type: "edit", id: row.original.id } })}
                                        className="cust-btn "
                                    >
                                        <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                                    </button>
                                }
                            </div>
                        </React.Fragment >
                    );
                },
            },
        ],
        []
    );


    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                    User({count})
                </h2>

                <div className='d-flex gap-3'>
                    <div className='search-input'>
                        <input onChange={(e) => usersList(1, e.target.value)} type='text' placeholder='Search' style={{ border: 'none', width: '150px', fontFamily: 'f1' }} />
                        <img src={search_icon} className='search' />
                    </div>

                </div>

            </div>


            <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />
        </div>
    )
}

export default UsersList